import { Currency } from "@types";
import { CardType } from "kz-ui-sdk";

/**
 * Default card types for Peru bank accounts
 * Used as fallback when server doesn't provide cardTypes in funding profile settings
 */
export const DEFAULT_CARD_TYPES: CardType[] = [CardType.Checking, CardType.Saving];

export type BankInfoFormFields =
  | "name"
  | "bank"
  | "accountNumber"
  | "pan"
  | "paymentMethod"
  | "upi"
  | "cpf"
  | "pixKey"
  | "curp"
  | "clabeNumber"
  | "pid"
  | "bankTypeOption"
  | "ifsc"
  | "cci"
  | "cardType";

export type BankInfoFormFieldItem =
  | BankInfoFormFields
  | [BankInfoFormFields, { options: string[] }]
  | [BankInfoFormFields, { options: string[] }, { options: string[] }];

/**
 * Bank funding profile form field configuration per currency
 * Defines which fields are required/available for each currency's bank account form
 */
export const BANK_INFO_FORM_FIELDS: Record<Currency, BankInfoFormFieldItem[]> = {
  [Currency.THB]: ["name", "bank", "accountNumber"],
  [Currency.PHP]: ["name", "bank", "accountNumber"],
  [Currency.IDR]: ["name", "bank", "accountNumber"],
  [Currency.BDT]: ["name", "bank", "accountNumber"],
  [Currency.PKR]: ["name", "bank", "accountNumber"],
  [Currency.INR]: [
    [
      "bankTypeOption",
      {
        options: ["upi", "bank"],
      },
    ],
    "name",
    "pan",
    "accountNumber",
    "ifsc",
  ],
  [Currency.BRL]: ["name", "cpf", "pixKey"],
  [Currency.MXN]: ["name", "curp", "clabeNumber"],
  [Currency.PEN]: ["name", "bank", "pid", "cardType", "accountNumber", "cci"],
  [Currency.EGP]: ["name", "bank", "accountNumber"],
  [Currency.COP]: ["name", "bank", "pid", "cardType", "accountNumber"],
};
